import { Button } from '@/components/Button'
import {
  Section,
  SectionItem,
} from '@/features/jobs/info-gathering/components/Section'

export interface DependentsProfileItem {
  id?: string
  title: string
  dateOfBirth: string
  personalTaxpayerIdentificationNumber: string
  maskedPersonalTaxpayerIdentificationNumber: string
}

export interface DependentsProfileProps {
  dependents: DependentsProfileItem[]
  isLoading: boolean
  isEditable: boolean
  onEdit?: () => void
  editButtonTestId?: string
}

export function DependentsProfile({
  dependents,
  isLoading,
  isEditable,
  onEdit,
  editButtonTestId,
}: DependentsProfileProps) {
  return (
    <div>
      {dependents.map((dependent, index) => (
        <Section
          key={dependent.id}
          title={dependent.title}
          isLoading={isLoading}
          actions={
            index === 0 && isEditable ? (
              <Button
                label="Edit"
                variant="text"
                onPress={onEdit}
                testId={editButtonTestId}
              />
            ) : undefined
          }
        >
          <SectionItem
            label="Date of birth"
            value={dependent.dateOfBirth}
            isSensitive
          />

          <SectionItem
            label="SSN or ITIN"
            value={dependent.personalTaxpayerIdentificationNumber}
            maskedValue={dependent.maskedPersonalTaxpayerIdentificationNumber}
            isSensitive
          />
        </Section>
      ))}
    </div>
  )
}
